import React, { Component } from 'react';
import SocialContainer from 'components/SocialContainer/SocialContainer';
import NavFooter from 'components/Layout/Navigation/Navigation';
import { Link } from 'react-router-dom';

import { Logo } from '../../../assets/images/index.js';
import { I18n } from 'react-i18next';
import i18n from '../../../i18n';

export default class Footer extends Component {
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <footer className='footer-container mt200'>
            <div className='wrapper'>
              <div className='footer mb42 mt42'>
                <Logo />
                <span />
                <div className='footer-contact__info'>
                  <a href='/vacatures' className='mb10 fs16 f-bold ls1-1'>
                    {t('footernavVacancy')}
                  </a>
                  <Link
                    className='mb10 fs16 f-bold ls1-1'
                    to='/vacatures#student'
                  >
                    {t('footernavEducation')}
                  </Link>
                  <a href='/over-fpg' className='mb10 fs16 f-bold ls1-1'>
                    {t('footernavAbout')}
                  </a>
                  <a href='/contact' className='mb10 fs16 f-bold ls1-1'>
                    {t('footernavContact')}
                  </a>
                </div>
                <SocialContainer />
                <div className='mobile-logo'>
                  <Logo />
                </div>
              </div>
            </div>
          </footer>
        )}
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Includes/Footer.jsx